exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".form-container.container {\n  width: 100%; }\n  .form-container.container .row {\n    text-align: center;\n    margin: auto;\n    max-width: 600px; }\n  .form-container.container .input-group {\n    margin: 10px auto 20px; }\n  .form-container.container .btn.btn-link {\n    padding-right: 0; }\n  .form-container.container .panel-footer p {\n    font-size: 85%; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/components/login/login.component.scss
// module id = 499
// module chunks = 0